import React from "react";
import { motion } from "framer-motion";
import "../pages/OurStoryAboutUs.css";
import OurStoryImg from "../assets/aboutmodel.webp";
export default function OurStory() {
  // Parent container animation
  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: { staggerChildren: 0.3 },
    },
  };

  // Child fade & slide
  const fadeSlideUp = {
    hidden: { opacity: 0, y: 40 },
    show: { opacity: 1, y: 0, transition: { duration: 0.8 } },
  };

  return (
    <section className="ourstory-section">
      <motion.div
        className="ourstory-wrapper"
        variants={container}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, amount: 0.3 }}
      >
        {/* Heading */}
        <motion.h2 className="ourstory-title" variants={fadeSlideUp}>
          Our Story
        </motion.h2>

        {/* Content Grid */}
        <div className="ourstory-content">
          {/* Left Image */}
          <motion.div
            className="ourstory-image"
            variants={fadeSlideUp}
            whileHover={{ scale: 1.05 }}
            transition={{ type: "spring", stiffness: 150 }}
          >
            <img
              src={OurStoryImg}
              alt="Our Story"
            />
          </motion.div>

          {/* Right Text */}
          <motion.div className="ourstory-textbox" variants={fadeSlideUp}>
            <h3>Maya Exports Limited</h3>
            <p>
            From local roots to global reach, we bridge markets with excellence in imports and exports. Our story is built on trust, quality, and a passion for connecting businesses worldwide.
            </p>
            <motion.a
              href="/contact"
              className="ourstory-btn"
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.95 }}
            >
              Contact us
            </motion.a>
          </motion.div>
        </div>
      </motion.div>
    </section>
  );
}
